// Tier values -- MUST match backend/core/tiering.py `Tier` (a backend test compares them).
export const TIER_VALUES = ["none", "heuristic", "suspected", "confirmed", "cleared", "auto_confirmed"];
// Filter options: "" means "all tiers".
export const TIERS = ["", ...TIER_VALUES];
